import { createAction, props } from '@ngrx/store';

import { UserModel } from '@lockton-apps/client-gateway/interfaces';

import { BrokerCreateUpdateActionTypes } from './actions.model';

export const initCreate = createAction(
  BrokerCreateUpdateActionTypes.InitCreate
);
export const initUpdate = createAction(
  BrokerCreateUpdateActionTypes.InitUpdate
);

export const added = createAction(
  BrokerCreateUpdateActionTypes.Added,
  props<{ userModel: UserModel }>()
);

export const updated = createAction(
  BrokerCreateUpdateActionTypes.Updated,
  props<{ userModel: UserModel }>()
);

export const destroyed = createAction(BrokerCreateUpdateActionTypes.Destroyed);
